import React from 'react'

const CheckMark = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="63" viewBox="0 0 64 63" fill="none">
            <g id="Group 111">
                <circle id="Ellipse 1" cx="31.5349" cy="31.5" r="31.5" fill="#ACFE6C" />
                <path id="Vector 1" d="M14.6177 36.4L27.3701 48L49.2517 19" stroke="#396A22" strokeWidth="4" strokeLinecap="round" />
            </g>
        </svg>
    )
}

export default CheckMark